import { render, staticRenderFns } from "./qualificationDetails.vue?vue&type=template&id=0d6b7465&scoped=true"
import script from "./qualificationDetails.vue?vue&type=script&lang=js"
export * from "./qualificationDetails.vue?vue&type=script&lang=js"
import style0 from "./qualificationDetails.vue?vue&type=style&index=0&id=0d6b7465&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6b7465",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d6b7465')) {
      api.createRecord('0d6b7465', component.options)
    } else {
      api.reload('0d6b7465', component.options)
    }
    module.hot.accept("./qualificationDetails.vue?vue&type=template&id=0d6b7465&scoped=true", function () {
      api.rerender('0d6b7465', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualificationDetails/qualificationDetails.vue"
export default component.exports